import { useState } from 'react';
import { inject } from 'mobx-react';
import { confirmAlert } from 'react-confirm-alert';

import withLocalization from '../../../../../hoc/withLocalization.js';
import Button from '../../../../../components/CustomButton/CustomButton.jsx';

import Input from '../../../../../elements/Input.js';
import WagetypeRefetch from '../../WagetypeRefetch.js';

const XledgerWidget = (props) => {
    const availableEmpToken = props.clientStore.currentEntity.client?.integration_details?.emp_token || '';
    const client_id = props.clientStore.currentEntity.client.id;
    const { t, commonStore, clientStore } = props;
    const [emp_token, setEmpToken] = useState(props.clientStore.currentEntity.client?.integration_details?.emp_token || '');
    const [product, setProduct] = useState(props?.payrollProduct || '');
    const [active, setIsActive] = useState(props.clientStore.currentEntity.client?.integration_details?.active || false);
    const [isLoadingMetaData, setIsLoadingMetaData] = useState(false);
    const [lastUpdatedMetaData, setLastUpdatedMetaData] = useState(commonStore.integrationMetaData?.projects?.last_updated || null);

    async function handleReset() {
        try {
            const str = `${t(`Do You want to Reset the integration with`)} ${product}`
            confirmAlert({
                title: `${t('Are You Sure')}`,
                message: str,
                buttons: [
                    {
                        label: t('Yes'),
                        onClick: async () => {
                            await clientStore.saveXledgerDetails({ resetIntegration: true, product, emp_token })
                            commonStore.addNotification(t('Integration Reset Successful'), null, 'success');
                            setEmpToken("");
                            setIsActive(false);
                            setProduct("");
                            await clientStore.load(clientStore.currentEntity.client.id)
                        },
                    },
                    {
                        label: t('No')
                    },
                ],
            })
        }
        catch (err) {
            commonStore.addNotification(t(err || 'error'), null, 'error');
        }
    }

    async function handleValidate(e) {
        try {
            await clientStore.saveXledgerDetails({ emp_token, product });
            commonStore.addNotification(t('Token verified successfully') + ', ' + t('Please complete the integration settings.'), null, 'success');
            setIsActive(true);
            if (props.handleSubTabChange) {
                await clientStore.load(client_id);
                props.handleSubTabChange('payroll_integrations_settings');
            }
        }
        catch (err) {
            commonStore.addNotification(t(err || 'error'), null, 'error');
        }
    }

    const refetchMetaData = async () => {
        try {
            await commonStore.getIntegrationMetaData({ refetch: true });
            commonStore.addNotification(t('Successfully refetched metadata'), null, 'success');
            const _lastUpdated = commonStore.integrationMetaData?.projects?.last_updated
            setLastUpdatedMetaData(_lastUpdated);
            setIsLoadingMetaData(false);
        } catch (err) {
            console.error(err);
            commonStore.addNotification(t('Something went wrong'), null, 'error');
            setIsLoadingMetaData(false);
        }
    }

    return (
        <>
            {product && availableEmpToken && (
                <WagetypeRefetch
                    t={t}
                    refetch={() => {
                        setIsLoadingMetaData(true);
                        refetchMetaData();
                    }}
                    lastUpdated={lastUpdatedMetaData}
                    isLoading={isLoadingMetaData}
                    dateTimeRules={commonStore.getDateTimeRules()}
                    text={t('We store recent project, employee, and task data for better search suggestions. If newly added items don’t appear, please use the refetch')}
                />
            )}
            <Input
                className={'mt-4'}
                label={'API Token'}
                name="emp_token"
                placeholder={t('Enter API Token')}
                value={emp_token}
                onChange={(event) => setEmpToken(event.target.value)}
                disabled={active}
            />
            <div className="d-flex justify-content-between mt-4">
                <Button className="btn btn-fill" onClick={handleValidate}>
                    {t('Validate Token')}
                </Button>
                <Button
                    className="btn"
                    onClick={handleReset}
                    disabled={!active}
                    title={t('It will Reset your connection with current available Intgration')}
                >
                    {t('Reset Integration')}
                </Button>
            </div>
        </>
    );

}

export default inject('commonStore', 'clientStore')(withLocalization(XledgerWidget));